// Number / date / string formatting — one place, used by every view.

export function inr(n) {
  return '₹' + Math.round(n || 0).toLocaleString('en-IN');
}

export function inrShort(n) {
  n = Math.round(n || 0);
  if (Math.abs(n) >= 1e7) return '₹' + (n / 1e7).toFixed(2).replace(/\.00$/, '') + ' Cr';
  if (Math.abs(n) >= 1e5) return '₹' + (n / 1e5).toFixed(2).replace(/\.00$/, '') + ' L';
  if (Math.abs(n) >= 1e3) return '₹' + (n / 1e3).toFixed(1).replace(/\.0$/, '') + 'K';
  return '₹' + n;
}

export const num = (n) => (n || 0).toLocaleString('en-IN');

export function pct(a, b) {
  return b ? (100 * a) / b : 0;
}

export function deltaPct(cur, prev) {
  return prev > 0 ? (100 * (cur - prev)) / prev : null;
}

export function fmtPct(x, d = 1) {
  return (x || 0).toFixed(d) + '%';
}

export function dfmt(iso) {
  if (!iso) return '—';
  return new Date(iso + 'T00:00').toLocaleDateString('en-IN', { day: '2-digit', month: 'short' });
}

export function dfmtLong(iso) {
  if (!iso) return '—';
  return new Date(iso + 'T00:00').toLocaleDateString('en-IN', {
    weekday: 'short', day: '2-digit', month: 'short', year: 'numeric',
  });
}

export function initials(n) {
  return (n || '')
    .split(' ')
    .map((w) => w[0])
    .filter(Boolean)
    .slice(0, 2)
    .join('')
    .toUpperCase();
}

export function computeAge(dob) {
  if (!dob) return null;
  const d = new Date(dob);
  const now = new Date();
  if (isNaN(d)) return null;
  let a = now.getFullYear() - d.getFullYear();
  const m = now.getMonth() - d.getMonth();
  if (m < 0 || (m === 0 && now.getDate() < d.getDate())) a--;
  return a >= 0 && a < 150 ? a : null;
}

export function personSub(l) {
  return [l.gender, l.dob ? computeAge(l.dob) + 'y' : ''].filter(Boolean).join(' · ');
}

export const todayISO = () => new Date().toISOString().slice(0, 10);
